<template>
  <div class="hello">
    <meta name="apple-itunes-app" content="app-clip-bundle-id=cdfsunrise.cdflehu.clip-membership, app-id=id1587662715">
    <h4>{{ msg }}</h4>
    <button type="dashed" @click="loginAction()">
      H5
    </button>
  </div>
</template>

<script>

import {
  defineComponent, onMounted,
  // openURL
} from 'vue'

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components: {
    
  },


  setup() {
    // const loginAction = () => {
    //   console.log('loginActionxxxx')
  
    //   location.href="https://appclip.apple.com/id?p=com.cdfsunrise.cdflehu.clip-membership"
    // }

    onMounted(() => {
      console.log('onMounted')
      loginAction()
    })

    // 延迟1秒跳转
    const loginAction = () => setTimeout(() => {
      console.log('loginActionxxxx')
      location.href="https://appclip.apple.com/id?p=com.cdfsunrise.cdflehu.clip-membership"
    }, 1000)

    return {
      loginAction
    }
  }
})

// export default {

// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
